"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("egov-ui-kit/redux/form/actions");

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "ownerInfo",
  fields: {
    name: {
      id: "name",
      jsonPath: "Properties[0].owners[0].name",
      type: "textfield",
      floatingLabelText: "Owner Name",
      required: true,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      pattern: (0, _utils.getPattern)("Name"),
      errorMessage: "owner name required!"
    },
    gender: {
      id: "gender",
      jsonPath: "Properties[0].owners[0].gender"
    }
  },

  beforeInitForm: function beforeInitForm(action, store, dispatch) {
    try {
      var count = 0;
      var state = store.getState();

      var formData = (0, _get2.default)(state, "form", {});

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(formData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (key.indexOf("ownerInfo") !== -1) count = count + 1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var propertyData = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties", {});

      propertyData[0].owners.forEach(function (x, i) {
        dispatch((0, _actions.setFieldProperty)("ownerInfo_" + i, "name", "value", x.name));
        dispatch((0, _actions.setFieldProperty)("ownerInfo_" + i, "gender", "value", x.gender));
      });

      if (count !== 1 && count !== 0) {
        dispatch((0, _actions.setFieldProperty)("ownerInfo_" + (count - 1), "name", "required", true));
        dispatch((0, _actions.setFieldProperty)("ownerInfo_" + (count - 1), "gender", "required", true));
      }

      return action;
    } catch (e) {
      return action;
    }
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};
exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/ownerInfo.js
// module id = 1682
// module chunks = 1137